import React from 'react';
import { TextField } from '@material-ui/core';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

const styles = {
  input: {
    background: '#f2f2f2',
    padding: '1rem',
    fontSize: '1.5rem',
    lineHeight: '2.5rem',
    color: '#222',
    fontWeight: '300',
  },
};

const Amount = ({ onChange, value, classes }) => (
  <TextField
    id="amount"
    label="Betrag"
    value={value.toString().replace('.', ',')}
    onChange={onChange}
    fullWidth
    autoComplete="off"
    InputProps={{
      classes: {
        input: classes.input,
      },
    }}
  />
);

Amount.propTypes = {
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  onChange: PropTypes.func.isRequired,
  classes: PropTypes.instanceOf(Object).isRequired,
};

Amount.defaultProps = {
  value: 0,
};


export default withStyles(styles)(Amount);



// WEBPACK FOOTER //
// ./src/components/calculator/Amount.js